import { render } from "./CookiesModal.vue?vue&type=template&id=c7f92798&scoped=true"
import script from "./CookiesModal.vue?vue&type=script&lang=js"
export * from "./CookiesModal.vue?vue&type=script&lang=js"

import "./CookiesModal.vue?vue&type=style&index=0&id=c7f92798&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7f92798"]])

export default __exports__